var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "program_composition"
  }, [_c("div", {
    staticClass: "bg-main"
  }, [_c("Title", {
    staticClass: "bg-title",
    attrs: {
      title: "解决方案"
    }
  }), _c("div", {
    staticClass: "section-content"
  }, [_c("section", {
    staticClass: "content1"
  }, [_c("div", {
    staticClass: "module-left"
  }, _vm._l(_vm.diagnosisSolutionsList, function (item, index) {
    return _c("Card", {
      key: index,
      attrs: {
        icon: item.img,
        desc1: item.desc1,
        desc2: item.desc2
      }
    });
  }), 1), _c("div", {
    staticClass: "module-right"
  }, [_c("img", {
    attrs: {
      src: _vm.imgUrl[0],
      alt: ""
    }
  }), _vm._m(0)])]), _c("section", {
    staticClass: "content2"
  }, [_c("div", {
    staticClass: "module-left"
  }, [_c("img", {
    attrs: {
      src: _vm.imgUrl[1],
      alt: ""
    }
  }), _vm._m(1)]), _c("div", {
    staticClass: "module-right"
  }, _vm._l(_vm.assistantSolutionsList, function (item, index) {
    return _c("Card", {
      key: index,
      attrs: {
        icon: item.img,
        desc1: item.desc1,
        desc2: item.desc2
      }
    });
  }), 1)]), _c("section", {
    staticClass: "content3"
  }, [_c("div", {
    staticClass: "module-left"
  }, _vm._l(_vm.innovationSolutionsList, function (item, index) {
    return _c("Card", {
      key: index,
      attrs: {
        icon: item.img,
        desc1: item.desc1,
        desc2: item.desc2
      }
    });
  }), 1), _c("div", {
    staticClass: "module-right"
  }, [_c("img", {
    attrs: {
      src: _vm.imgUrl[2],
      alt: ""
    }
  }), _vm._m(2)])])])], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title"
  }, [_c("p", {
    staticClass: "text"
  }, [_vm._v("AI影像辅助诊断解决方案")]), _c("p", {
    staticClass: "baseLine"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title"
  }, [_c("p", {
    staticClass: "text"
  }, [_vm._v("AI智能辅医疗解决方案")]), _c("p", {
    staticClass: "baseLine"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title"
  }, [_c("p", {
    staticClass: "text"
  }, [_vm._v("临床科研实验创新解决方案")]), _c("p", {
    staticClass: "baseLine"
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };